/* eslint-disable no-console */
import MedicalReportMixin from '@/shared/mixins/medical-report.mixin'
import AnalystReportMixin from '@/shared/mixins/analyst-report.mixin'
import AuthMixin from '@/shared/mixins/auth.mixin'
import CONSTANTS from '@/shared/constants/constants'
import imgMedicalReport from '@/assets/img/medical-report.png'
import imgSendInformation from '@/assets/img/send-information.png'
import imgReportTimeout from '@/assets/img/report-timeout.png'
import imgReceiveInformation from '@/assets/img/receive-information.png'
import imgReceiveRectification from '@/assets/img/retification-warning.png'
import { mapActions } from 'vuex'

const STILL_REPORTING_DIALOG_MARGIN_IN_PIXELS = 24
const STILL_REPORTING_MIN_POSITION_DIFFERENCE_IN_PIXELS = 120

export default {
  name: 'feedback',
  mixins: [
    MedicalReportMixin,
    AnalystReportMixin,
    AuthMixin
  ],
  data () {
    return {
      newExamInterval: 0,
      type: '',
      message: '',
      imgFeedback: '',
      instructionText: '',
      seconds: 10,
      timeRemaining: 0,
      monitor: Object,
      interval: Object,
      showDialog: false,
      hasCountDown: true,
      hasUpcomingExams: true,
      hasNewExamMonitor: false,
      needAlertPermission: false,
      silentAlertPermission: false,
      messageStopReport: this.$i18n.tc('feedback.stop_report', 1),
      imgMedicalReport,
      imgSendInformation,
      imgReportTimeout,
      imgReceiveInformation,
      imgReceiveRectification,
      showTokenButton: false,
      isStillReportingFromInactivity: false,
      lastStillReportingPosition: null
    }
  },

  beforeDestroy () {
    this.changeTitleInterval(false)
    this.stopCountDown()
    this.stopNewExamMonitor()
    this.$root.$off('showFeedbackPopup', this.onShowFeedbackPopup)
    this.$root.$off('pauseStillReportingPopup', this.onPauseStillReportingPopup)
  },
  mounted () {
    if (this.isAnalyst()) {
      this.messageStopReport = this.$i18n.tc('feedback.stop_report', 2)
    }
    this.onShowFeedbackPopup = this.handleShowFeedbackPopup
    this.$root.$on('showFeedbackPopup', this.onShowFeedbackPopup)
    this.onPauseStillReportingPopup = () => {
      if (this.type === 'stillReporting' && this.showDialog) {
        this.showDialog = false
      }
    }
    this.$root.$on('pauseStillReportingPopup', this.onPauseStillReportingPopup)
  },
  methods: {
    ...mapActions(['changeTitleInterval']),
    isAnalyst () {
      const role = this.getFirstRole()
      return role === CONSTANTS.ROLES.ANALYST
    },
    isWarnMessage () {
      return this.type === 'warnMessage' || this.type === 'rectificationMessage'
    },
    handleShowFeedbackPopup (isStillReportingFromInactivity) {
      this.isStillReportingFromInactivity = Boolean(isStillReportingFromInactivity)
      this.showFeedback(true, 'stillReporting')
    },
    showFeedback (hasUpcomingExams, type) {
      this.stopCountDown()
      this.type = type
      this.showDialog = true
      this.hasUpcomingExams = hasUpcomingExams
      this.instructionText = ''
      this.message = ''
      if (type !== 'stillReporting') {
        this.isStillReportingFromInactivity = false
      }
      if (type === 'sendInformation') {
        this.checkCertificateAndToken()
      }

      switch (type) {
        case 'warnMessage':
          this.imgFeedback = this.imgReceiveInformation
          this.message = this.$i18n.t('feedback.exam_new_info')
          this.instructionText = this.$i18n.t('feedback.exam_has_new_info_verify_history')
          this.hasCountDown = false
          break

        case 'rectificationMessage':
          this.imgFeedback = this.imgReceiveRectification
          this.message = this.$i18n.t('feedback.exam_new_rectification')
          this.instructionText = this.$i18n.t('feedback.exam_has_new_rectification')
          this.hasCountDown = false
          break

        case 'unassign':
          this.imgFeedback = this.imgReportTimeout
          this.instructionText = this.$i18n.t('feedback.time_to_report_exceeded')
          this.hasCountDown = false
          break
        case 'sendInformation':
          this.imgFeedback = this.imgSendInformation
          this.message = this.$i18n.t('feedback.message_sent_sucessfully')
          this.instructionText = this.$i18n.t('feedback.when_requesting_source_answer')
          break

        case 'dontHaveExams':
          this.imgFeedback = this.imgMedicalReport
          this.instructionText = this.$i18n.t('feedback.want_to_be_notified_when_new_exams')
          this.needAlertPermission = true
          break

        case 'notifyNewExam':
          this.imgFeedback = this.imgMedicalReport
          this.instructionText = this.$i18n.t('feedback.we_inform_when_new_exams_arrive')
          this.hasNewExamMonitor = true
          this.silentAlertPermission = true
          this.needAlertPermission = false
          this.newExamMonitor()
          this.changeTitleInterval(false)
          break

        case 'newExamArrived':
          this.imgFeedback = this.imgMedicalReport
          this.instructionText = this.$i18n.t('feedback.new_exam_arrived')
          this.hasNewExamMonitor = false
          this.silentAlertPermission = false
          this.changeTitleInterval(true)
          break

        case 'stillReporting':
          this.imgFeedback = this.imgReportTimeout
          this.instructionText = this.$i18n.t('feedback.still_reporting')
          this.hasCountDown = false
          break

        default:
          this.imgFeedback = this.imgMedicalReport
          this.instructionText = this.$i18n.t('feedback.successfully_sent')
          this.changeTitleInterval(false)
          break
      }

      this.countDown()
      this.checkIfShowNotify()
      if (type === 'stillReporting') {
        this.$nextTick(this.updateStillReportingDialogPosition)
      }
    },
    ok () {
      this.showDialog = false
    },
    continueReporting () {
      this.showDialog = false
      if (!this.isStillReportingFromInactivity) {
        this.$root.$emit('refreshCountdownEvent')
      }
      this.$root.$emit('stillReportingContinue', {
        isStillReportingFromInactivity: this.isStillReportingFromInactivity,
        routeName: this.$route && this.$route.name
      })
      this.isStillReportingFromInactivity = false
    },
    toggleAlertPermission () {
      this.silentAlertPermission = !this.silentAlertPermission
    },
    stopCountDown () {
      clearInterval(this.interval)
    },
    stopNewExamMonitor () {
      clearInterval(this.monitor)
    },
    getStillReportingDialogElement () {
      const feedbackDialog = document.querySelector('#feedback')
      if (!feedbackDialog) {
        return null
      }
      let dialogElement = feedbackDialog

      if (!dialogElement.classList.contains('md-dialog')) {
        dialogElement = feedbackDialog.querySelector('.md-dialog')
      }
      if (!dialogElement) {
        return null
      }
      return dialogElement
    },
    updateStillReportingDialogPosition () {
      const dialogElement = this.getStillReportingDialogElement()
      if (!dialogElement) {
        return
      }
      const maxLeft = Math.max(
        STILL_REPORTING_DIALOG_MARGIN_IN_PIXELS,
        window.innerWidth - dialogElement.offsetWidth - STILL_REPORTING_DIALOG_MARGIN_IN_PIXELS
      )
      const maxTop = Math.max(
        STILL_REPORTING_DIALOG_MARGIN_IN_PIXELS,
        window.innerHeight - dialogElement.offsetHeight - STILL_REPORTING_DIALOG_MARGIN_IN_PIXELS
      )
      const { left, top } = this.getStillReportingDialogPosition(maxLeft, maxTop)
      dialogElement.style.setProperty('--still-reporting-left', `${left}px`)
      dialogElement.style.setProperty('--still-reporting-top', `${top}px`)
      this.lastStillReportingPosition = { left, top }
    },
    getStillReportingDialogPosition (maxLeft, maxTop) {
      let left = this.getRandomStillReportingPosition(maxLeft)
      let top = this.getRandomStillReportingPosition(maxTop)
      let attempt = 0
      while (
        this.lastStillReportingPosition &&
        this.isSameStillReportingRegion(left, top) &&
        attempt < 10
      ) {
        left = this.getRandomStillReportingPosition(maxLeft)
        top = this.getRandomStillReportingPosition(maxTop)
        attempt++
      }
      return { left, top }
    },
    isSameStillReportingRegion (left, top) {
      return (
        Math.abs(this.lastStillReportingPosition.left - left) < STILL_REPORTING_MIN_POSITION_DIFFERENCE_IN_PIXELS &&
        Math.abs(this.lastStillReportingPosition.top - top) < STILL_REPORTING_MIN_POSITION_DIFFERENCE_IN_PIXELS
      )
    },
    getRandomStillReportingPosition (maxPosition) {
      if (maxPosition <= STILL_REPORTING_DIALOG_MARGIN_IN_PIXELS) {
        return STILL_REPORTING_DIALOG_MARGIN_IN_PIXELS
      }
      return Math.floor(
        Math.random() * (maxPosition - STILL_REPORTING_DIALOG_MARGIN_IN_PIXELS + 1)
      ) + STILL_REPORTING_DIALOG_MARGIN_IN_PIXELS
    },
    stop () {
      this.logoutUser()
    },
    next () {
      this.showDialog = false
      this.stopCountDown()
      this.$emit('next')
    },
    countDown () {
      this.timeRemaining = this.seconds
      if (!this.hasUpcomingExams || !this.hasCountDown) {
        return
      }

      this.interval = setInterval(() => {
        this.timeRemaining--
        if (this.timeRemaining <= 0) {
          this.next()
        }
      }, 1000)
    },
    getClassButton () {
      if (this.hasUpcomingExams) {
        return 'button-next-enabled'
      }
      return 'button-next-disabled'
    },
    checkIfShowNotify () {
      if (!this.hasUpcomingExams && !this.hasNewExamMonitor && !this.needAlertPermission) {
        this.redirectToAlertOnNewExam()
      }
    },
    showNotifyNewExam () {
      this.showFeedback(this.hasUpcomingExams, 'notifyNewExam')
    },
    redirectToAlertOnNewExam () {
      setTimeout(() => {
        this.showNotifyNewExam()
      }, 5000)
    },
    newExamMonitor () {
      if (this.hasUpcomingExams || !this.hasNewExamMonitor) {
        return
      }

      this.monitor = setInterval(() => this.checkForNewExams(), 60000)
    },
    async checkForNewExams () {
      const { data: hasNewExam } = this.isAnalyst()
        ? await this.analystHasMoreExams() : await this.hasMoreExams()
      if (hasNewExam) {
        const notificationAlert = new Audio('/assets/sound/notification-sound.mp3')
        notificationAlert.muted = !this.silentAlertPermission
        notificationAlert.play()
        this.showFeedback(hasNewExam, 'newExamArrived')
        this.stopNewExamMonitor()
      }
    },
    async checkCertificateAndToken() {
      const validation = JSON.parse(sessionStorage.getItem('certificateValidation'))

      if (validation && validation.cert) {
        const { token, tokenExpiration } = validation

        if (this.isTokenValid(token, tokenExpiration)) {
          this.updateShowTokenButton(tokenExpiration)
        } else if (!token && this.shouldCallValidateCertificate()) {
          try {
            const response = await this.getValidateCertificate()
            if (this.isTokenValid(response.token, response.tokenExpiration)) {
              this.updateShowTokenButton(response.tokenExpiration)
            } else {
              this.showTokenButton = false
            }
          } catch (error) {
            console.error('Erro ao validar o certificado:', error)
            this.showTokenButton = false
          }
        } else {
          this.showTokenButton = false
        }
      } else {
        this.showTokenButton = false
      }
    },
    isTokenValid(token, tokenExpiration) {
      return token && tokenExpiration && new Date() < new Date(tokenExpiration)
    },
    updateShowTokenButton(tokenExpiration) {
      const expirationDate = new Date(tokenExpiration)
      const currentDate = new Date()
      const timeDifference = expirationDate - currentDate
      const timeRemainingHours = timeDifference / (1000 * 60 * 60)

      this.showTokenButton = timeRemainingHours < 24
    },
    redirectToValidation() {
      window.location.href = '/medico/validate'
    }
  }
}
